import React from "react";
import { Checkbox } from "@/components/ui/checkbox";
import { CheckCircle2 } from "lucide-react";

import { CONFIG } from "@/lib/api";
export const QC_ITEMS = new Proxy([], { get: (t, k) => { const src = CONFIG.qc_items?.length ? CONFIG.qc_items : [
  { key: "colour", label: "Colour matches the approved artwork" },
  { key: "size", label: "Size / dimensions are correct" },
  { key: "finishing", label: "Finishing (laminate, cutting, eyelet) is flawless" },
  { key: "quantity", label: "Quantity complete & no defects" },
]; const v = src[k]; return typeof v === "function" ? v.bind(src) : v; } });

export const qcComplete = (c) => QC_ITEMS.every((i) => c?.[i.key]);

export const QcChecklist = ({ value = {}, onChange, disabled = false, compact = false }) => (
  <div className="space-y-2" data-testid="qc-checklist">
    {QC_ITEMS.map((i) => (
      <label key={i.key} className={`flex items-start gap-3 rounded-md border p-2 cursor-pointer hover:bg-muted/40 ${value[i.key] ? "border-emerald-300 bg-emerald-50 dark:bg-emerald-950/30" : ""}`}>
        <Checkbox checked={!!value[i.key]} disabled={disabled} onCheckedChange={(v) => onChange({ ...value, [i.key]: !!v })} data-testid={`qc-item-${i.key}`} className="mt-0.5" />
        <span className={`${compact ? "text-xs" : "text-sm"}`}>{i.label}</span>
      </label>
    ))}
    {qcComplete(value) && <div className="text-xs text-emerald-600 flex items-center gap-1" data-testid="qc-complete"><CheckCircle2 className="w-3.5 h-3.5" /> All QC items passed</div>}
  </div>
);
